import { SET_HIDE_UNUSED_GROUPS } from './constants';

type State = boolean;

type Action = {
    +type: string,
    +payload: Object
};

const initialState = false;

export default function(state: State = initialState, action: Action) {
    switch (action.type) {
        case SET_HIDE_UNUSED_GROUPS:
            return action.payload.hideUnusedGroups;
        default:
            return state;
    }
}
